import GuestlistCreateModalController from "../../../../modules/guestlists/controllers/modals/create-modal-controller";
import createModalTemplate from "../../../../modules/guestlists/views/modals/create-modal.tpl.html";
import GuestlistAfterCreateModalController
    from "../../../../modules/guestlists/controllers/modals/after-create-modal-controller";
import afterCreateModalTemplate from "../../../../modules/guestlists/views/modals/after-create-modal.tpl.html";

class DashboardDefaultController {
    constructor(scope, $uibModal, $state, $translate, Guestlists, Acl, Users, ResourceCommon, Alert) {
        this.scope = scope;
        this.uibModal = $uibModal;
        this.state = $state;
        this.translate = $translate;
        this.acl = Acl;
        this.usersStore = Users;
        this.resourceCommon = ResourceCommon;
        this.alert = Alert;

        this.guestlists = [];
        this.currentGuestlist = null;
        this.loading = true;
        this.displayType = 'checkin';
        this.checkedInRate = 0;
        this.store = Guestlists.reset({
            persists: false,
            listview: 'DashboardGuestlistListView'
        });
        this.store.commit('setFilters', []);
        this.init();
    }

    init() {
        this.customExports = _.get(this.usersStore.state, 'company.settings.companies.custom_exports', []);

        this.updateGuestlists().then(() => {
            this.loading = false;
            this.apply();
        }, () => {
            this.apply();
        });
    }

    createGuestlist() {
        return this.uibModal.open({
            controller: GuestlistCreateModalController,
            controllerAs: 'vm',
            templateUrl: createModalTemplate
        }).result.then((data) => {
            const guestlistData = data.guestlist;

            this.alert.success(this.translate.instant('guestlists.workflows.create-guestlist.messages.created.title'), this.translate.instant('guestlists.workflows.create-guestlist.messages.created.message'));
            this.state.go('app.guestlists.rsvps.index', {gid: guestlistData.id});

            return this.uibModal.open({
                controller: GuestlistAfterCreateModalController,
                controllerAs: 'vm',
                templateUrl: afterCreateModalTemplate,
                resolve: {
                    guestlist: () => {
                        return guestlistData;
                    }
                }
            }).result.then(() => {

            }, () => {

            });
        }, () => {
            console.log('modal closed');
        });
    }

    doCustomExport(customExport) {
        this.resourceCommon.download(this.decorateCustomExportParameter(customExport.url), customExport.downloadFileName).then(() => {
            this.alert.success('Download started');
        }, response => {
            this.error = true;
            if (response.status === 404) {
                this.alert.error('File not found');
            } else {
                this.alert.handle(response);
            }
        });
    }

    decorateCustomExportParameter(stringToDecorate) {
        return stringToDecorate.replace('##CURRENT_GUESTLIST##', this.currentGuestlist.id);
    }

    updateGuestlists() {
        this.guestlists = [];

        if (_.get(this.usersStore, 'state.loggedin.profile.settings.core.enable_all_lists_dashboard', false)) {
            this.guestlists.push({
                name: 'All active lists',
                date: null,
                id: null
            });
        }

        const colsToSelect = [
            'name',
            'date',
            'id',
            'count_rsvps_confirmed',
            'sum_pax_planned_confirmed',
            'sum_pax_actual_confirmed'
        ];


        return new Promise((resolve, reject) => {
            this.store.dispatch('getDefinitions').then(() => {
                let newColumns = [];
                _.forEach(this.store.getters.columns, function (curCol) {
                    curCol.visible = colsToSelect.indexOf(curCol.key) > -1;

                    newColumns.push(curCol);
                });
                this.store.commit('setColumns', newColumns);
                let sort = {
                    date: 'asc'
                };
                this.store.commit('setSort', sort);

                this.store.dispatch('getData').then(() => {
                    this.guestlists = this.store.state.data;
                    if (!this.currentGuestlist || this.guestlists.indexOf(this.currentGuestlist) === -1) {
                        this.selectGuestlist(this.guestlists[0]);
                    }
                    resolve(this.guestlists);
                }, (e) => {
                    reject(e);
                });
            }, (e) => {
                reject(e);
            });
        });
    }

    selectGuestlist(guestlist) {
        this.currentGuestlist = guestlist;
        const guestlistDate = new Date(this.currentGuestlist),
            currentDate = new Date();
        this.checkedInRate = 0;
        if (this.currentGuestlist && this.currentGuestlist.sum_pax_actual_confirmed > 0) {
            this.checkedInRate = Math.ceil((this.currentGuestlist.sum_pax_actual_confirmed / this.currentGuestlist.sum_pax_planned_confirmed) * 100);
        }

        if (guestlistDate.getFullYear() < currentDate.getFullYear()
            || (
                (guestlistDate.getFullYear() === currentDate.getFullYear())
                && (guestlistDate.getMonth() < currentDate.getMonth())
            )
            || (
                (guestlistDate.getFullYear() === currentDate.getFullYear())
                && (guestlistDate.getMonth() === currentDate.getMonth())
                && (guestlistDate.getDay() <= currentDate.getDay())
            )
        ) {
            this.displayType = 'checkin';
        } else {
            this.displayType = 'default';
        }
        this.scope.$evalAsync();
    }

    apply() {
        this.scope.$evalAsync();
    }
}

DashboardDefaultController.$inject = [
    '$scope',
    '$uibModal',
    '$state',
    '$translate',
    'Guestlists',
    'Acl',
    'Users',
    'ResourceCommon',
    'Alert'
];


angular
    .module('festzelt-os.dashboard')
    .controller('DashboardDefaultController', DashboardDefaultController);



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/components/default/controller.js